import { render, staticRenderFns } from "./flexVolume.vue?vue&type=template&id=dd0d5cca&"
import script from "./flexVolume.vue?vue&type=script&lang=js&"
export * from "./flexVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports